if (!customElements.get('oscar-partners')) {
  customElements.define('oscar-partners', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.setAttribute('data-ready', '');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.toggleAttribute('data-in-view', entries.some(entry => entry.isIntersecting));
        }, { threshold: 0.01 });
        this.observer.observe(this);
      } else {
        this.setAttribute('data-in-view', '');
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}
